var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { UserRoles } from "../user/user.types";
import { UIModelPartnerShort } from "../partners/partners.model";
import { UIModelProfile } from "@/api/user/user.model";
import { decodeTokenData } from "@/api/utils";
import MPStorage from "@/services/LocalStorage";
import { customKeys } from "@/services/LocalStorage/LocalStorage";
import MPSessionStorage from "@/services/MPSessionStorage";
var UIModelLogin = /** @class */ (function () {
    function UIModelLogin(response) {
        this.accessToken = response.accessToken;
        var _a = decodeTokenData(this.accessToken), expiresIn = _a.expiresIn, userId = _a.userId;
        this.userId = userId;
        this.expiresIn = expiresIn;
    }
    return UIModelLogin;
}());
export { UIModelLogin };
var UIModelHubProfileClient = /** @class */ (function () {
    function UIModelHubProfileClient(response) {
        this.id = response.id;
        this.partnerId = response === null || response === void 0 ? void 0 : response.partnerId;
        this.clientName = response === null || response === void 0 ? void 0 : response.clientName;
        this.orgName = response === null || response === void 0 ? void 0 : response.orgName;
        this.name = response === null || response === void 0 ? void 0 : response.name;
    }
    return UIModelHubProfileClient;
}());
export { UIModelHubProfileClient };
var UIModelHubProfileOrganization = /** @class */ (function () {
    function UIModelHubProfileOrganization(response) {
        this.id = response.id;
        this.partnerId = response === null || response === void 0 ? void 0 : response.partner_id;
        this.orgName = response === null || response === void 0 ? void 0 : response.org_name;
    }
    return UIModelHubProfileOrganization;
}());
export { UIModelHubProfileOrganization };
var UIModelHubProfile = /** @class */ (function (_super) {
    __extends(UIModelHubProfile, _super);
    function UIModelHubProfile(response) {
        var _this = _super.call(this, response) || this;
        _this.partners = (response === null || response === void 0 ? void 0 : response.partners)
            ? response.partners.map(function (partner) { return new UIModelPartnerShort(partner); })
            : [];
        _this.clients = response.clients
            ? response.clients.map(function (client) { return new UIModelHubProfileClient(client); })
            : [];
        _this.activePartner = response.activePartner;
        _this.organizations = response.organizations
            ? response.organizations.map(function (organization) { return new UIModelHubProfileOrganization(organization); })
            : [];
        _this.orgName = response.orgName;
        var newLocalization = MPSessionStorage.get(MPSessionStorage.keys.NEW_LOCALIZTIONS);
        if (newLocalization) {
            // extract partner id from localization, format: "/dashboard/app/CmfFRDPA/permissions"
            var extractedId = newLocalization.split("/")[3];
            var looksLikeOrgName = !extractedId ||
                extractedId.includes(" ") ||
                extractedId.toLowerCase() === "initial signup organization";
            if (extractedId && !looksLikeOrgName) {
                MPStorage.saveToLocalStorage(customKeys.PARTNER_ID, extractedId);
            }
        }
        return _this;
    }
    Object.defineProperty(UIModelHubProfile.prototype, "isAdmin", {
        get: function () {
            return this.roles.includes(UserRoles.ADMIN);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UIModelHubProfile.prototype, "isPartner", {
        get: function () {
            return this.roles.some(function (role) { return role.startsWith("partner"); });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UIModelHubProfile.prototype, "isUser", {
        get: function () {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UIModelHubProfile.prototype, "isClient", {
        get: function () {
            return this.roles.some(function (role) { return role.startsWith("client"); });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UIModelHubProfile.prototype, "isPartnerOwner", {
        get: function () {
            return this.roles.includes(UserRoles.PARTNER_OWNER);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UIModelHubProfile.prototype, "isPartnerMember", {
        get: function () {
            return this.roles.includes(UserRoles.PARTNER_MEMBER);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UIModelHubProfile.prototype, "isPartnerPerfMsgSpecialist", {
        get: function () {
            return this.roles.includes(UserRoles.PARTNER_PERF_MSG_SPECIALIST);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UIModelHubProfile.prototype, "isClientOwner", {
        get: function () {
            return this.roles.includes(UserRoles.CLIENT_OWNER);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UIModelHubProfile.prototype, "isClientMember", {
        get: function () {
            return this.roles.includes(UserRoles.CLIENT_MEMBER);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UIModelHubProfile.prototype, "isClientPerfMsgSpecialist", {
        get: function () {
            return this.roles.includes(UserRoles.CLIENT_PERF_MSG_SPECIALIST);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UIModelHubProfile.prototype, "hasPartnerOwnerPermissions", {
        // Helper methods to check for "owner-like" permissions (owner or perf-msg-specialist)
        get: function () {
            return this.isPartnerOwner || this.isPartnerPerfMsgSpecialist;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UIModelHubProfile.prototype, "hasClientOwnerPermissions", {
        get: function () {
            return this.isClientOwner || this.isClientPerfMsgSpecialist;
        },
        enumerable: false,
        configurable: true
    });
    return UIModelHubProfile;
}(UIModelProfile));
export { UIModelHubProfile };
//# sourceMappingURL=data:application/json;base64,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